import { render, staticRenderFns } from "./Serviceside.vue?vue&type=template&id=03517d08&"
import script from "./Serviceside.vue?vue&type=script&lang=js&"
export * from "./Serviceside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports